
<template lang="html">

  <div class="main-container">


     <section class="mobile">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="masthead-logo-mobile mobile">
              <img :src="'static/img/common/logo.png'" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <mast-head
      ref="mst" 
      page="takeaway"
    >
    </mast-head>

    <section>
      <div class="container"> 
        <div class="row intro-box">
          <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center">
<!--             <p class="mobile" v-html="home.subtitle"></p> -->
            <h3 class="h3-subtitle"  v-html="takeaway.subtitle"></h3>

          </div>
        </div>
      </div>

    </section>

<!--     <section>
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
            <a :href="takeaway.menu_link" class="router-link-container link-button-no-margin" target="_blank"><link-button :label="takeaway.menu_button"></link-button></a>
          </div>
        </div>
      </div>
    </section>
 -->
    <section class="section-no-pad-top">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
             
            <p v-for="(p, index) in takeaway.body" class="page-paragraph" v-html="p"></p>
         
             <a :href="takeaway.shopify_link" target="_blank" class="router-link-container"><link-button :label="takeaway.order_button"></link-button></a>
          </div>
        </div>
      </div>
    </section>

<!--     <section class="section-no-pad-top">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center">
            <img :src="'static/img/content/takeaway/TDW_cropped.jpg'" />
            <p v-for="(p, index) in takeaway.body" class="page-paragraph" v-html="p"></p>
            <a :href="takeaway.shopify_link" target="_blank" class="router-link-container"><link-button :label="takeaway.order_button"></link-button></a>
          </div>
        </div>
      </div>
    </section> -->

    <section class="pure-text-centered" id="clients">
      <client-section></client-section>
    </section>

    <section>
      <contact-section></contact-section>
    </section>

    <section class="section-joined-bottom">
      <text-ticker page="food"></text-ticker>
    </section>

    <section class="section-joined-top">
      <footer-image></footer-image>
    </section>
  </div>

</template>

<style type="text/css" scoped>
  
  

</style>

<script>

// var dataURL = 'https://api.ralphandco.com/updates'
import MastHead from '../components/MastHead'
import {commontools} from '../mixins/Styling'
import LinkButton from '../components/LinkButton'
import FooterImage from '../components/FooterImage'
import TextTicker from '../components/TextTicker'
import ContactSection from '../components/ContactSection'
import MyCarousel from '../components/MyCarousel.vue'
import ClientSection from '../components/ClientSection'
import {takeaway} from '../../content.json'

export default {
  mixins: [commontools],
  name: 'takeaway',
  watch: {
    '$route.name': function (id) {
      window.scrollTo(0, 0)
    }
  },
  data () {
    return {
      takeaway,
      metatitle: '',
      loadCounter: 0
    }
  },
  methods: {
  },
  created: function () {

  },
  mounted: function () {
    window.scrollTo(0, 0)
    // setTimeout(() => {
    //   this.manageWidows()
    // }, 100)
  },
  components: {
    MastHead,
    LinkButton,
    FooterImage,
    TextTicker,
    ContactSection,
    ClientSection,
    MyCarousel
  }
}
</script>


// WEBPACK FOOTER //
// Takeaway.vue?822099c4